import DurationInterval from './DurationInterval';

export default DurationInterval;
